import Image from '@base/Image';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_16B};
  overflow: hidden;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 341px;
  position: relative;

  ${mediaQuery.uptoMobile} {
    height: 350px;
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const RatingsAndLevels = () => {
  const isMobile = useIsMobile();
  return (
    <>
      <Wrapper>
        <Typography variant={isMobile ? 'h5' : 'h4'}>
          Ratings and levels
        </Typography>
        <ImageWrapper>
          <Image
            src={
              isMobile
                ? '/compete/levels-mobile.svg'
                : '/compete/levels-desktop.svg'
            }
            alt="levels"
            layout="fill"
          />
        </ImageWrapper>
      </Wrapper>
    </>
  );
};

export default RatingsAndLevels;
